
























import Vue from 'vue';
import Component from 'vue-class-component';
import Timeout = NodeJS.Timeout;

@Component({
    name: 'dayco-loader',
})
export default class Loader extends Vue {
    value: number = 0;
    query: boolean = false;
    interval: Timeout | null = null;
    color: string = 'primaryGreen';
    showLoader: boolean = false;

    mounted() {
        this.queryAndIndeterminate();
    }

    beforeDestroy() {
        clearInterval(this.interval!);
    }

    queryAndIndeterminate() {
        this.query = true;
        this.value = 0;
        this.color = 'secondaryBlue1';

        setTimeout(() => {
            this.query = false;
            this.color = 'primaryGreen';

            this.interval = setInterval(() => {
                clearInterval(this.interval!);
                return setTimeout(this.queryAndIndeterminate, 500);
            }, 500);
        }, 1000);
    }
}
